import { SET_CONTACT_US_SEND_SUCCEEDED, SET_REPORT_THIS_ISSUE_SEND_SUCCEEDED } from "../actions/types";

const initialState = {
  sendSucceeded: false,
  reportThisIssueSucceeded: false
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CONTACT_US_SEND_SUCCEEDED: {
      return { ...state, sendSucceeded: payload };
    }
    case SET_REPORT_THIS_ISSUE_SEND_SUCCEEDED: {
      return { ...state, reportThisIssueSucceeded: payload };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/contactUsReducer.js